import powerTransformer from './power';
import domainTransformer from './domain';
import { LOCALE } from '../../common/constants';

export default function heroTransformer({
  translations = {}, powers, domain, ...hero
}, i) {
  return {
    ...hero,
    level: hero.level || i + 2,
    ...translations[LOCALE],
    powers: powers.map(power => powerTransformer({ ...power, hero })),
    domain: domainTransformer(domain),
  };
}
